import React from 'react';
import { Container, Box, Text, Heading } from 'theme-ui';

import { withInView } from '@utils';
import { Section, Markdown } from '@snippets';

import { Schema } from './Testimonials.schema';
import { StarRating } from './StarRating';

export const Testimonials = withInView(
  ({ cms }) => {
    const { section, text, testimonials, display } = cms;

    if (!testimonials || testimonials.length === 0) return null;

    // Validate testimonial structure
    const validTestimonials = testimonials.filter(
      (testimonial) =>
        testimonial &&
        testimonial.reviewText != null &&
        testimonial.reviewerName != null
    );

    if (validTestimonials.length === 0) return null;

    const getGridColumns = (testimonialsLength) => {
      if (testimonialsLength === 1) return '1fr';
      if (testimonialsLength === 2) return 'repeat(2, 1fr)';
      return 'repeat(3, 1fr)';
    };
    const textColor = section?.color || '#222222';

    return (
      <Section section={section}>
        <Container data-comp={Testimonials.displayName}>
          {text?.heading && (
            <Box
              sx={{
                textAlign: text.textAlign || 'center',
                mb: [4, 5],
              }}
            >
              <Markdown
                text={text?.heading}
                as="h2"
                sx={{
                  fontSize: [36, 56],
                  fontFamily: 'Reckless Neue',
                  fontWeight: 400,
                  color: textColor,
                  lineHeight: 1.2,
                  '& *': {
                    fontFamily: 'Reckless Neue!important',
                  },
                }}
              />
            </Box>
          )}

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: [
                '1fr',
                getGridColumns(validTestimonials.length),
              ],
              gap: 11,
              justifyItems: validTestimonials.length < 3 ? 'center' : 'stretch',
              maxWidth: validTestimonials.length < 3 ? '800px' : '100%',
              mx: validTestimonials.length < 3 ? 'auto' : 0,
            }}
          >
            {validTestimonials.map((testimonial, index) => (
              <Box
                key={index}
                as="article"
                role="article"
                aria-label={`Testimonial by ${testimonial.reviewerName}`}
                sx={{
                  bg: '#ffffff',
                  px: [11, 12],
                  py: 11,
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                  maxWidth: validTestimonials.length < 3 ? '350px' : 'none',
                  textAlign: 'center',
                }}
              >
                {display?.showStars !== false && (
                  <StarRating rating={5} size={16} color={textColor} />
                )}

                <Text
                  as="blockquote"
                  sx={{
                    fontSize: 4,
                    fontFamily: 'Fellix',
                    fontWeight: 400,
                    color: textColor,
                    lineHeight: 1.5,
                    flex: 1,
                  }}
                >
                  {testimonial.reviewText}
                </Text>

                <Text
                  as="cite"
                  sx={{
                    fontSize: 1,
                    fontFamily: 'Fellix',
                    fontWeight: 400,
                    color: textColor,
                    mt: 'auto',
                  }}
                >
                  {testimonial.reviewerName}
                </Text>
              </Box>
            ))}
          </Box>
        </Container>
      </Section>
    );
  },
  { triggerOnce: true }
);

Testimonials.displayName = 'Testimonials';
Testimonials.Schema = Schema;
